module.exports = __webpack_public_path__ + "img/wifi-block-poplar.1ba51218.png";